/*カルーセル*/
$(function () {
	var swiper = new Swiper('.swiper-container', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		loop: true,
		observer: true,
		observeParents: true,
    speed: 1500,
		  autoplay: {
        delay: 800,
        disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
		  },
    /*simulateTouch: false,*//*クリックでスワイプしない*/
		/*loopedSlides: 3,*/
		/*centeredSlides : true,*/
		slideToClickedSlide: true,
		spaceBetween: 20,
		/*slidesPerGroup: 2,*/
    slidesPerView: 2,
		breakpoints: {
			// 768px以上の場合
			768: {
        /*slidesPerGroup: 4,*/ //4枚ずつスライド
				slidesPerView: 4,
			}
		}
	});
 
});